import React from 'react';

import { UseFormReturn, FieldValues, FieldPath } from 'react-hook-form';

import { FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { Textarea } from 'src/registry/ui/Textarea';

type TextareaFormFieldProps<TData extends FieldValues> = {
    form: UseFormReturn<TData>;
    name: FieldPath<TData>;
    label: string;
    className?: React.InputHTMLAttributes<HTMLInputElement>['className'];
    disabled?: boolean;
    inlineTitle?: string;
    required?: boolean;
};

export default function TextareaFormField<TData extends FieldValues>({
    form,
    name,
    label,
    className,
    disabled,
    inlineTitle,
    required,
}: TextareaFormFieldProps<TData>) {
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem variant="dialog">
                    <FormLabel variant="dialog" required={required}>
                        {label}
                    </FormLabel>
                    <FormControlStack>
                        <FormControl>
                            <Textarea
                                {...field}
                                inlineTitle={inlineTitle}
                                className={className}
                                disabled={disabled}
                                placeholder={`${label}...`}
                            />
                        </FormControl>
                        <FormMessage />
                    </FormControlStack>
                </FormItem>
            )}
        />
    );
}
